import {
    OPEN_MODAL_READY,
    CLOSE_MODAL_READY,
    OPEN_ERROR_MODAL
} from './Modals.actions';
import { ModalIdTypes, ModalActions } from './Modals.types';
import { mergeStates } from '../iwProvider/StoreHelper';

const initialState: ModalIdTypes = {
    openModalId: null,
    errorModalId: null
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = mergeStates(initialState),
    action: ModalActions = { id: null, type: null }
) {
    switch (action.type) {
        case OPEN_MODAL_READY:
            return mergeStates(state, {
                openModalId: action.id
            });

        case CLOSE_MODAL_READY:
            return mergeStates(state, {
                openModalId: null
            });

        case OPEN_ERROR_MODAL:
            return mergeStates(state, {
                errorModalId: action.id
            });

        default:
            return state;
    }
}
